import { z } from "zod";

export const publicBookingSearchSchema = z.object({
  coachId: z.coerce.number().optional().catch(undefined),
  coachName: z.string().optional().catch(undefined),
  email: z.string().trim().email().optional().catch(undefined),
  name: z.string().trim().min(1).optional().catch(undefined),
});
